export default [
  {
    id: '001',
    date: '2020.01.24',
    title: 'メインキャスト発表！オフィシャルコメントも到着！',
    description: '本日公開のティザーPVにて、魅力的なキャラクター陣も登場し、演じるキャストも解禁となりました。自称“日本一の天才詐欺師”枝村真人役に小林千晃、世界を飛び回るフランス人…',
    image: '/assets/images/news-001_s.jpg',
    text:
      '<p>本日公開のティザーPVにて、魅力的なキャラクター陣も登場し、演じるキャストも解禁となりました。</p>' +
      '<p>自称“日本一の天才詐欺師”枝村真人役に小林千晃、世界を飛び回るフランス人のコンフィデンスマンのローラン・ティエリー役に諏訪部順一、運動神経抜群のコンフィデンス・ウーマンのアビゲイル・ジョーンズ役に藤原夏海、FBI敏腕捜査官のポーラ・ディキンス役に園崎未恵が決定！本作への意気込みが伝わるオフィシャルコメントも到着！</p>' +
      '<figure><img src="/assets/images/news-001_l.jpg" alt="キャスト"></figure>'
  },
  {
    id: '002',
    date: '2020.01.24',
    title: 'ティザービジュアル＆ティザーPV公開！',
    description: '2020年夏の放送に向け、ティザービジュアルが公開となりました！宙に吊り下げられ絶体絶命の主人公で新米詐欺師の枝村真人（えだむら・まこと）の姿と、詐欺師として七変化する…',
    image: '/assets/images/news-002_s.jpg',
    text:
      '<p>2020年夏の放送に向け、ティザービジュアルが公開となりました！</p>' +
      '<p>宙に吊り下げられ絶体絶命の主人公で新米詐欺師の枝村真人（えだむら・まこと）の姿と、詐欺師として七変化する枝村の様々な表情が描かれています。</p>' +
      '<p>' +
        'さらに、ティザーPVも公開！世界中のあらゆる都市で活躍するコンフィデンスマンたちの壮大でスリリングなアクションシーンが続々登場！<br>' +
        '目が離せない迫力ある映像が展開します！ぜひチェックしてください！' +
      '</p>'
  },
  {
    id: '003',
    date: '2020.01.24',
    title: '2020年夏、世界はきっと騙される―。放送時期発表！Netflixにて全世界独占配信も決定！',
    description: 'TVアニメ『GREAT PRETENDER』の放送が発表となりました。2020年 7 月よりフジテレビ「＋Ultra」、BSフジほか各局にて放送予定。Netflix にて全世界独占配信（日本先行）…',
    image: '/assets/images/no-image_2x.png',
    text:
      '<p>TVアニメ『GREAT PRETENDER』の放送が発表となりました。</p>' +
      '<p>2020年 7 月よりフジテレビ「＋Ultra」、BSフジほか各局にて放送予定。Netflix にて全世界独占配信（日本先行）</p>' +
      '<p>放送開始まで、どうぞお楽しみに！</p>'
  },
  {
    id: '004',
    date: '2020.01.27',
    title: 'AnimeJapan 2020にて、ステージ参戦が決定！',
    description: '3月21日（土）・22日（日）に、東京ビッグサイトで開催される、日本最大級のアニメイベント“AnimeJapan 2020”にて、日本国内初のステージイベント実施が決定しました！',
    image: '/assets/images/no-image_2x.png',
    text:
      '<p>3月21日（土）・22日（日）に、東京ビッグサイトで開催される、日本最大級のアニメイベント“AnimeJapan 2020”にて、日本国内初のステージイベント実施が決定しました！</p>' +
      '<dl>' +
        '<dt>ステージ名</dt>' +
        '<dd>「GREAT PRETENDER」“詐欺師（コンフィデンスマン）集結！”スペシャルステージ</dd>' +
        '<dt>日時</dt>' +
        '<dd>3月22日（日）16:30～17:00</dd>' +
        '<dt>会場</dt>' +
        '<dd>東京ビッグサイトAnimeJapan 2020会場内MOON YELLOW ステージ</dd>' +
        '<dt>登壇者</dt>' +
        '<dd>' +
          '小林千晃（枝村真人＜エダマメ＞役）／諏訪部順一（ローラン・ティエリー役）／藤原夏海（アビゲイル・ジョーンズ＜アビー＞役）<br>' +
          '鏑木ひろ（監督）／古沢良太（脚本・シリーズ構成）' +
        '</dd>' +
        '<dt></dt>' +
        '<dd style="margin-top: 1rem; line-height: 1.25rem;">' +
          '※MOON  YELLOWステージはオープンステージとなり、AnimeJapanの入場券をお持ちのお客様はどなたでもご観覧いただけます。<br>' +
          '※出演者情報やステージ内容は変更になる可能性がございますので、ご了承ください。' +
        '</dd>' +
      '</dl>' +
      '<p>' +
        '2020年夏、世界はきっと騙されるー。キャスト・スタッフが語る、桁違いなスケールの＜コン・ゲーム＞の行方とは......！？<br>' +
        'イベントの各種チケットも本日より発売開始！AnimeJapanやチケットの詳細は、下記ページをご覧ください！' +
      '</p>' +
      '<dl>' +
        '<dt>AnimeJapan公式HP</dt>' +
        '<dd><a target="_blank" href="https://www.anime-japan.jp">https://www.anime-japan.jp</a></dd>' +
      '</dl>'
  },
  {
    id: '005',
    date: '2020.03.06',
    title: 'AnimeJapan 2020開催中止に伴うチケット払い戻しのお知らせ',
    description: '「新型コロナウイルス感染症」の広がりにより、AnimeJapan 2020が開催中止になったことに伴う、チケット払い戻しが行われます。',
    image: '/assets/images/no-image_2x.png',
    text:
      '<p>「新型コロナウイルス感染症」の広がりにより、AnimeJapan 2020が開催中止になったことに伴う、チケット払い戻しが行われます。</p>' +
      '<dl>' +
        '<dt>期間</dt>' +
        '<dd>2020年3月6日（金）～31日（火）</dd>' +
        '<dt>詳細</dt>' +
        '<dd>AnimeJapan公式HPをご覧ください。' +
          '<br><a target="_blank" href="https://www.anime-japan.jp/ticket/refund/">https://www.anime-japan.jp/ticket/refund/</a>' +
        '</dd>' +
      '</dl>' +
      '<p>イベントを楽しみにしくださっていた皆様には大変心苦しいですが、体調にはくれぐれもお気をつけください。『グレプリ』を、今後とも何卒よろしくお願いいたします。</p>'
  },
  {
    id: '006',
    date: '2020.05.08',
    title: 'TV放送・配信開始日が決定！',
    description: 'TV放送・配信開始日が決定しました！ロサンゼルス、シンガポール、ロンドン、上海、そして東京…。CASE1～4それぞれで異なる都市を舞台に、詐欺師(コンフィデンスマン)たちが…',
    image: '/assets/images/no-image_2x.png',
    /* eslint-disable */
    text:
      '<p>TV放送・配信開始日が決定しました！ロサンゼルス、シンガポール、ロンドン、上海、そして東京…。CASE1～4それぞれで異なる都市を舞台に、詐欺師(コンフィデンスマン)たちが贈る、痛快クライム・エンタテインメントをお楽しみに！</p>' +
      '<p>2020年7月8日よりフジテレビ「＋Ultra」にて毎週水曜日24時55分から放送<br>BSフジ、ほか各局にて放送<br>※放送日時は変更の可能性があります。</p>' +
      '<p><em>2020年6月2日よりNetflixにて順次 独占先行配信</em>' +
        '<br>CASE1（1話～5話） 　6月2日' +
        '<br>CASE2（6話～10話） 　6月9日' +
        '<br>CASE3（11話～14話）　6月16日' +
        '<br>CASE4　Coming Soon' +
        '<br>※配信日時は変更の可能性があります。' +
      '</p>'
      /* eslint-enable */
  },
  {
    id: '007',
    date: '2020.05.08',
    title: 'キービジュアル第1弾、メインPV第1弾を解禁！',
    description: 'キービジュアル第1弾、メインPV第1弾を解禁しました！キービジュアルでは、エダマメこと枝村真人、ローラン・ティエリー、アビゲイル・ジョーンズ（アビー）、ポーラ・ディキン…',
    image: '/assets/images/news-007_s.jpg',
    text:
      '<p>キービジュアル第1弾、メインPV第1弾を解禁しました！</p>' +
      '<p>キービジュアルでは、エダマメこと枝村真人、ローラン・ティエリー、アビゲイル・ジョーンズ（アビー）、ポーラ・ディキンス4人が集結！彼らの背後には、標的となる悪党、大金、財宝の数々が…！</p>' +
      '<p>メインPV第1弾では、新米詐欺師のエダマメが、ローランに誘われ、標的となるハリウッドマフィアの元へ向かう物語の導入を初紹介！主要キャラクターたちの、新カットやセリフも盛り沢山です！</p>' +
      '<p>詐欺師(コンフィデンスマン)の宴にようこそ。</p>'
  },
  {
    id: '008',
    date: '2020.05.22',
    title: 'コミカライズが決定！',
    description: '6月10日（水）マグコミおよびLINEマンガにて、コミカライズ配信が決定！7月10日（金）コミックス第1巻が発売！',
    image: '/assets/images/news-008_s.jpg',
    text:
      '<p>6月10日（水）マグコミおよびLINEマンガにて、コミカライズ配信が決定！<br>7月10日（金）コミックス第1巻が発売！</p>' +
      '<p>' +
        '<em>マグコミはコチラ</em><br>' +
        '<a style="color:#fff;" href="https://magcomi.com/" target="_blank" rel="noopener">https://magcomi.com/</a>' +
      '</p>' +
      '<figure>' +
        '<img src="/assets/images/news-008_l.jpg" alt="コミックス">' +
      '</figure>'
  },
  {
    id: '009',
    date: '2020.05.22',
    title: 'プロジェクトPV公開！',
    description: '主要スタッフが、企画意図やキャラクター・演出についてなど、『グレプリ』制作の舞台裏を熱く語るPVを公開しました！',
    image: '/assets/images/news-009_s.jpg',
    text:
      '<p>主要スタッフが、企画意図やキャラクター・演出についてなど、『グレプリ』制作の舞台裏を熱く語るPVを公開しました！</p>' +
      '<figure><img src="/assets/images/news-009_l.png" alt="プロジェクトPV"></figure>' +
      '<p>（上段左から）<br>監督　鏑木ひろ、脚本・シリーズ構成　古沢良太、サブキャラクターデザイン・総作画監督　加藤寛崇、WIT STUDIO プロデューサー　和田丈嗣、WIT STUDIO アニメーションプロデューサー　岡田麻衣子</p>' +
      '<p>配信開始間近、期待が高まります！ぜひお楽しみください！</p>'
  },
  {
    id: '010',
    date: '2020.05.29',
    title: 'TV放送・配信開始情報を更新しました！',
    description: '2020年7月8日よりフジテレビ「＋Ultra」にて毎週水曜日24時55分から放送　ほか各局にて放送',
    image: '/assets/images/no-image_2x.png',
    text:
      '<p><em>2020年7月8日よりフジテレビ「＋Ultra」にて毎週水曜日24時55分から放送</em>' +
        '<br>ほか各局にて放送（関西テレビ/東海テレビ/テレビ西日本/北海道文化放送/BSフジ）' +
        '<br>※放送日時は変更の可能性があります。' +
      '</p>' +
      '<p><em>2020年6月2日よりNetflixにて順次 独占先行配信</em>' +
        '<br>CASE1（1話～5話） 　6月2日' +
        '<br>CASE2（6話～10話） 　6月9日' +
        '<br>CASE3（11話～14話）　6月16日' +
        '<br>CASE4　Coming Soon' +
        '<br>※配信日時は変更の可能性があります。' +
      '</p>'
  },
  {
    id: '011',
    date: '2020.05.29',
    title: 'Netflix配信開始記念！1話配信イベントが、6月2日（火）18時30分より開催決定！',
    description: '6月2日（火）0時からのNetflixでのCASE1独占配信開始を記念し、1話配信イベントを、同日18時30分から開催します！アニメ本編の配信後には、スタッフ＆キャストによる特番も！…',
    image: '/assets/images/no-image_2x.png',
    text:
      '<p>6月2日（火）0時からのNetflixでのCASE1独占配信開始を記念し、1話配信イベントを、同日18時30分から開催します！アニメ本編の配信後には、スタッフ＆キャストによる特番も！<br>どなたでも視聴可能なイベントになりますので、ぜひお気軽にご参加ください！</p>' +
      '<dl>' +
      '  <dt>出演者</dt>' +
      '  <dd>鏑木監督、脚本・シリーズ構成 古沢良太、小林千晃（枝村真人役）、諏訪部順一（ローラン・ティエリー役）</dd>' +
      '  <dt>MC</dt>' +
      '  <dd>吉田尚記アナウンサー</dd>' +
      '  <dt>配信先</dt>' +
      '  <dd>Periscope（Netflix Anime Japan Twitter公式アカウント）<br>YouTube（TOHO animationチャンネル）</dd>' +
      '  <dt>内容</dt>' +
      '  <dd>1話配信＋スタッフ＆キャストトーク特番</dd>' +
      '</dl>' +
      '<p>※リモート出演でのイベントになります。</p>'
  },
  {
    id: '013',
    date: '2020.06.26',
    title: '第1話＆第2話TV放送時に、キャスト＆スタッフによるコメンタリー副音声が決定！',
    description: '第1話＆第2話TVアニメ放送時にコメンタリー副音声で放送が決定！枝村真人（エダマメ）役 小林千晃さん、ローラン・ティエリー役 諏訪部順一さんに加え、…',
    image: '/assets/images/no-image_2x.png',
    text:
      '<p>第1話＆第2話TVアニメ放送時にコメンタリー副音声で放送が決定！<br>' +
      '枝村真人（エダマメ）役 小林千晃さん、ローラン・ティエリー役 諏訪部順一さんに加え、第1話では脚本・シリーズ構成を手掛ける古沢良太さん、第2話では監督の鏑木ひろさんが登場！</p>' +
      '<p><em><第1話コメンタリー>　7月8日より各局 順次放送予定</em><br>' +
      '小林千晃（枝村真人役）、諏訪部順一（ローラン・ティエリー役）、古沢良太（脚本・シリーズ構成）</p>' +
      '<p><em><第2話コメンタリー>　7月15日より各局 順次放送予定</em><br>' +
      '小林千晃（枝村真人役）、諏訪部順一（ローラン・ティエリー役）、鏑木ひろ（監督）</p>' +
      '<p>企画の始まりや、それぞれのキャストが演じるキャラクターの印象、完成したアニメーション映像の感想など、制作のウラ話を交えながら濃密なトークをお届けします。<br>' +
      '放送とあわせて、コメンタリーにもご注目ください！</p>'
  },
  {
    id: '014',
    date: '2020.06.26',
    title: 'メインPV 第2弾・各CASEサブタイトル公開！',
    description: '7月8日（水）からのTV放送を前に、メインPV第2弾を公開しました。ロサンゼルス、シンガポール、ロンドン、上海、そして東京。CASEごとに異なる都市を舞台に…',
    image: '/assets/images/news-014_s.jpg',
    text:
      '<p>7月8日（水）からのTV放送を前に、メインPV第2弾を公開しました。ロサンゼルス、シンガポール、ロンドン、上海、そして東京。<br>' +
      'CASEごとに異なる都市を舞台に、スリリングな4つの事件（CASE）に挑むキャラクターたちの姿が、極上のドラマとともに描かれます。</p>' +
      '<a href="#005" class="video is-small">' +
      '  <figure><img src="/assets/images/pv-poster5.jpg" alt="メインPV2"></figure>' +
      '</a>' +
      '<p>Netflixにて配信中のCASE1～3までの物語の見どころに加え、本PVで初公開となるCASE4の最新映像も収録！作品の魅力をたっぷり詰め込んだPV映像をお楽しみください！</p>' +
      '<p>各CASEのサブタイトルも公開しました！<br>' +
      '　CASE１：Los Angeles Connection（ロサンゼルス・コネクション）<br>' +
      '　CASE２：Singapore Sky（シンガポール・スカイ）<br>' +
      '　CASE３：Snow of London（ロンドンの雪）<br>' +
      '　CASE４：Wizard of  Far East（極東の魔法使い）<br>' +
      '世界を股にかける、詐欺師（コンフィデンスマン）の宴をぜひお楽しみに！<p>'
  },
  {
    id: '015',
    date: '2020.06.26',
    title: 'TV放送情報を更新しました！',
    description: 'フジテレビ「＋Ultra」他各局にて放送！放送各局の情報が決定いたしました。…',
    image: '/assets/images/no-image_2x.png',
    text:
      '<p>フジテレビ「＋Ultra」他各局にて放送！放送各局の情報が決定いたしました。</p>' +
      '<p><em>フジテレビ「＋Ultra」他各局にて放送</em></p>' +
      '<p>フジテレビ：7月8日より 毎週水曜24:55~25：25<br>' +
      '関西テレビ：7月9日より 毎週木曜25:55~26：25<br>' +
      '東海テレビ：7月11日より 毎週土曜25:45~26：15<br>' +
      'テレビ西日本：7月8日より 毎週水曜25:55~26：25<br>' +
      '北海道文化放送：7月12日より 毎週日曜25:10~25：40<br>' +
      'BSフジ ：7月15日より 毎週水曜24:00~24：30</p>' +
      '<p>※放送日時は変更の可能性があります。</p>'
  },
  {
    id: '016',
    date: '2020.07.07',
    title: '主題歌がフレディ・マーキュリー「The Great Pretender」に決定！主題歌スペシャルPVも公開！',
    description: 'アニメ『GREAT PRETENDER』の主題歌が、フレディ・マーキュリーが歌う「ザ・グレート・プリテンダー」に決定しました。日本のTVアニメ史上で初めて …',
    image: '/assets/images/news-012_s.jpg',
    text:
      '<a href="#006" class="video is-small">' +
      '  <figure><img src="/assets/images/pv-poster4.jpg" alt="主題歌スペシャルPV"></figure>' +
      '</a>' +
      '<p>アニメ『GREAT PRETENDER』の主題歌が、フレディ・マーキュリーが歌う「ザ・グレート・プリテンダー」に決定しました。日本のTVアニメ史上で初めて、フレディ・マーキュリーの楽曲を主題歌として起用することになります！ </p>' +
      '<p>映画『ボヘミアン・ラプソディ』の大ヒットも記憶に新しいクイーンのフレディ・マーキュリー。彼が歌う「ザ・グレート・プリテンダー」(原題はThe Great Pretender)は、1987年2月にソロ名義で発表したシングルで、アメリカのヴォーカル・グループ、ザ・プラターズ(The Platters)が1956年に全米NO.1ヒットにした名曲のカヴァーです。このフレディが歌う名曲が、日本のTVアニメの主題歌として現代に蘇ります。“The Great Pretender”というタイトルとの共通性だけではなく、大した役者だと自身の心を偽って歌う心象風景をテーマにした世界観が、詐欺師（コンフィデンスマン）をテーマにした本作の物語にも寄り添います。</p>' +
      '<p>また、主題歌の解禁に伴い、楽曲とともに贈るスペシャルPVも公開しました！「ザ・グレート・プリテンダー」の繊細な歌詞や楽曲の美しさと、4人のキャラクターが織りなすドラマティックな物語が融合。世界各国を舞台にした壮大な景色や、キャラクターそれぞれの新たな表情が垣間見える最新映像です。楽曲の世界観とマッチした印象的なPVをお楽しみください！</p>' +
      '<p>　</p>' +
      '<figure class="is-small"><img src="/assets/images/news-016_l.jpg" alt></figure>' +
      '<p>' +
      '  <em>「ザ・グレート・プリテンダー」収録アルバム</em><br>' +
      '  <em>ネヴァー・ボーリング - ベスト・オブ・フレディ・マーキュリー（NEVER BORING / FREDDIE MERCURY）</em>' +
      '</p>' +
      '<p>' +
      '  CD: UICY-1583　定価: 2,500円＋税　発売・販売元: ユニバーサル ミュージック<br>' +
      '  日本盤のみSHM-CD仕様 「ザ・グレート・プリテンダー（2019スペシャル・エディション）」「ボーン・トゥ・ラヴ・ユー」他、全12曲収録' +
      '</p>' +
      '<p>' +
      '  同名のデジタル・アルバムも、各デジタル音楽ストアで好評発売中!!<br>' +
      '  <em>ストリーミング／ダウンロード: <a href="https://umj.lnk.to/great-pretender" target="_blank" rel="noopener">https://umj.lnk.to/great-pretender<a/></em>' +
      '</p>'
  },
  {
    id: '018',
    date: '2020.07.08',
    title: '第1話放送記念 プレゼントキャンペーンを開催！',
    description: '7月8日（水）からの放送開始を記念し、プレゼントキャンペーンを開催いたします！アニメ本編&スペシャル副音声コメンタリーをご覧のうえ、奮ってご参加ください！ …',
    image: '/assets/images/news-018_s.jpg',
    text:
      '<p>' +
      '  7月8日（水）からの放送開始を記念し、プレゼントキャンペーンを開催いたします！<br>' +
      '  アニメ本編&スペシャル副音声コメンタリーをご覧のうえ、奮ってご参加ください！' +
      '</p>' +
      '<dl>' +
      '  <dt>参加条件</dt>' +
      '  <dd>' +
      '    ①本アカウントフォロー<br>' +
      '    ② #グレプリ放送開始 で下記クイズの回答と第1話感想をツイート' +
      '  </dd>' +
      '  <dt>応募期間</dt>' +
      '  <dd>7/16（木）23:59まで</dd>' +
      '  <dt>【問題】</dt>' +
      '  <dd>枝村真人役 小林千晃さん、ローラン・ティエリー役 諏訪部順一さん、脚本・シリーズ構成 古沢良太さんご出演のスペシャル副音声で明かされる、監督が追加した台本になかった6文字の“ある台詞”（カタカナ）とは！？</dd>' +
      '</dl>' +
      '<p>' +
      '  抽選で5名様に、主要スタッフによるサインシートをプレゼントします！<br>' +
      '  各局順次放送になりますので、感想はネタバレなしでお願いいたします…！' +
      '</p>' +
      '<figure class="is-medium"><img src="/assets/images/news-018_l.jpg" alt></figure>'
  },
  {
    id: '017',
    date: '2020.07.09',
    title: '『GREAT PRETENDER 制作資料展』開催決定！',
    description: 'TV放送が開始となったアニメ『GREAT PRETENDER』で初の制作資料展の開催が決定しました！キャラクター設定や「Case1:Los Angeles Connection」の原画や背景美術などの…',
    image: '/assets/images/news-017_l.jpg',
    text:
      '<figure><img src="/assets/images/news-017_l.jpg" alt></figure>' +
      '<p>' +
      '  TV放送が開始となったアニメ『GREAT PRETENDER』で初の制作資料展の開催が決定しました！キャラクター設定や「Case1:Los Angeles Connection」の原画や背景美術などの制作資料の数々を展示するほか、オリジナルグッズの販売も行います！<br>' +
      '  この機会にぜひご来場ください。' +
      '</p>' +
      '<dl>' +
      '  <dt>開催名称</dt>' +
      '  <dd>『GREAT PRETENDER 制作資料展～Case1:Los Angeles Connection』</dd>' +
      '  <dt>開催日程</dt>' +
      '  <dd>2020年8月1日（土）～16日（日）</dd>' +
      '  <dt>営業時間</dt>' +
      '  <dd>平日： 11:00～19:00<br>土日祝： 10:00～18:00</dd>' +
      '  <dt>開催場所</dt>' +
      '  <dd>BOOKMARK 浅草橋</dd>' +
      '  <dt>入場料</dt>' +
      '  <dd>無料</dd>' +
      '  <dt>特設サイト</dt>' +
      '  <dd><a href="https://bookmark-asakusabashi.storeinfo.jp/posts/8601130" target="_blank" rel="noopener">https://bookmark-asakusabashi.storeinfo.jp/posts/8601130</a></dd>' +
      '</dl>' +
      '<p>' +
      '  ※展示する制作資料は複製物となります<br>' +
      '  ※入場方法に関しましては後日イベントページ及びBOOKMARK浅草橋公式Twitterにて発表いたします。<br>' +
      '  ※今後の新型コロナウィルス感染症の流行による国内の情勢並びに政府等からの自粛要請によっては再度イベントの開催内容の変更・中止の可能性がございます。' +
      '</p>'
  },
  {
    id: '019',
    date: '2020.08.11',
    title: 'メインPV第3弾（CASE 2 PV）公開！',
    description: '8月12日（水）からの【#6 CASE 2：シンガポール・スカイ】TV放送スタートを前に、メインPV第3弾を公開しました。次の舞台は 煌びやかに輝く南洋の近代都市・シンガポール。…',
    image: '/assets/images/news-019_s.jpg',
    text:
      '<p>8月12日（水）からの【#6 CASE 2：シンガポール・スカイ】TV放送スタートを前に、メインPV第3弾を公開しました。<br>' +
      '次の舞台は 煌びやかに輝く南洋の近代都市・シンガポール。<br>' +
      '標的は“エアレース”を牛耳る、産油国の兄弟王子！</p>' +
      '<a href="#007" class="video is-small">' +
      '  <figure><img src="/assets/images/pv-poster7.jpg" alt="メインPV3"></figure>' +
      '</a>' +
      '<p>八百長、裏カジノ、パイロットたちの意地、明かされるアビーの過去。<br>' +
      '新たな騙し合いの行方は…！？ぜひお楽しみに！</p>'
  },
  {
    id: '020',
    date: '2020.08.19',
    title: 'NetflixでのCASE 4 配信開始日が決定！',
    description: 'CASE 4 “Wizard of Far East”（極東の魔法使い）のNetflix独占先行配信の開始日が、9/21（月）に決定しました！…',
    image: '/assets/images/news-020_s.jpg',
    text:
      '<p>CASE 4  “Wizard of Far East”（極東の魔法使い）のNetflix独占先行配信の開始日が、9/21（月）に決定しました！</p>' +
      '<p>ターゲットはスカーレット商会の親会社『朱雀連合会』。<br>' +
      'ボスの朱雀アケミが児童売買を生業とする、反社会組織をめぐり、上海と東京を舞台にコン・ゲームがはじまります。<br>' +
      'さらにCASE 4では、いよいよローランの過去をめぐるエピソードも…！？</p>' +
      '<figure><img src="/assets/images/news-020-1.jpg" alt></figure>' +
      '<figure><img src="/assets/images/news-020-2.jpg" alt></figure>' +
      '<figure><img src="/assets/images/news-020-3.jpg" alt></figure>'
  },
  {
    id: '022',
    date: '2020.08.27',
    title: 'お茶に恋する、本格派ティーストア「THE ALLEY」とのタイアップが決定！',
    description: 'お茶に恋をする、本格派ティーストア「THE ALLEY（ジ アレイ）」とのタイアップが決定しました！…',
    image: '/assets/images/news-022_s.jpg',
    text:
      '<p>お茶に恋をする、本格派ティーストア「THE ALLEY（ジ アレイ）」とのタイアップが決定しました！<br>' +
      'CASE 2 シンガポール・スカイの本編中でエダマメとローランが飲んでいた「タピオカミルクティーLサイズ」にオリジナルステッカーが付いた商品が期間限定で7店舗にて発売されます！</p>' +
      '<figure><img src="/assets/images/news-022-1.jpg" alt></figure>' +
      '<figure><img src="/assets/images/news-022-3.jpg" alt></figure>' +
      '<p><em class="is-size-2 is-size-4-mobile">タイアップ情報</em></p>' +
      '<dl>' +
      '  <dt>タイアップ期間</dt>' +
      '  <dd>2020年9⽉3⽇（⽊）〜9⽉17⽇（⽊）</dd>' +
      '  <dt>POP UP店舗</dt>' +
      '  <dd>原宿店・秋葉原店</dd>' +
      '  <dt>発売商品</dt>' +
      '  <dd>ノベルティーステッカー付き タピオカミルクティー Lサイズ 780円（税抜）</dd>' +
      '</dl>' +
      '<p>オリジナルステッカーデザイン</p>' +
      '<figure class="is-medium"><img src="/assets/images/news-022-2.jpg" alt></figure>' +
      '<p><em>ノベルティ付き商品対象店舗　原宿店・秋葉原店・ニュウマン横浜店・ルミネ⼤宮店・NU茶屋町店・三宮店・サナギトラック</em></p>' +
      '<p>※ノベルティがなくなり次第配布は終了いたします。</p>' +
      '<p><em class="is-size-2 is-size-4-mobile">「THE ALLEY」 関連リンク</em></p>' +
      '<dl>' +
      '  <dt>⽇本 オフィシャルサイト</dt>' +
      '  <dd><a href="http://www.the-alley.jp" target="_blank" rel="noopener">http://www.the-alley.jp</a></dd>' +
      '  <dt>⽇本 Instagram</dt>' +
      '  <dd><a href="https://www.instagram.com/thealley.jp/" target="_blank" rel="noopener">https://www.instagram.com/thealley.jp/</a></dd>' +
      '  <dt>⽇本 Twitter</dt>' +
      '  <dd><a href="https://twitter.com/ThealleyJ" target="_blank" rel="noopener">https://twitter.com/ThealleyJ</a></dd>' +
      '</dl>'
  },
  {
    id: '021',
    date: '2020.09.07',
    title: '渋谷パルコにてポップアップストア開催決定！（特典状況追記）',
    description: '2020年9月11日（金）より渋谷パルコ6F Tokyo Otaku Mode TOKYOにてポップアップストアを開催いたします…',
    image: '/assets/images/news-021_s.jpg',
    text:
      '<p>2020年9月11日（金）より渋谷パルコ6F Tokyo Otaku Mode TOKYOにてポップアップストアを開催いたします。</p>' +
      '<figure><img src="/assets/images/news-021_l.jpg" alt></figure>' +
      '<p>主人公・枝村真人（エダマメ）やローランを始めとした一癖も二癖もある魅力的なキャラクターたちを店内に配し、描き下ろしイラストのオリジナルグッズを多数ご用意したポップアップストアでファンの皆さまをお待ちしております。<br>' +
      'また、購入特典として、グッズを3,000円（税込）以上お買上げごとにステッカーを1枚プレゼントいたします。<br>' +
      '※特典ステッカーの種類は選べません。</p>' +
      '<figure><img src="/assets/images/news-021-2.jpg" alt></figure>' +
      '<p>ポップアップストアにて販売される商品は 9月11日 午前11時よりTokyo Otaku Modeオンラインストア（<a href="https://ja.otakumode.com" target="_blank" rel="noopener">https://ja.otakumode.com/</a>)にて販売を開始いたします。<br>' +
      '※販売予定の商品内容は後日Tokyo Otaku Mode Twitter（日本語版）にて詳細をお伝えいたします。</p>' +
      '<p>　</p>' +
      '<p><em class="is-size-2 is-size-4-mobile">開催情報</em></p>' +
      '<dl>' +
      '  <dt>開催期間</dt>' +
      '  <dd>2020年9月11日（金）〜2020年10月8日（木）</dd>' +
      '  <dt>開催場所</dt>' +
      '  <dd>渋谷パルコ6F Tokyo Otaku Mode TOKYO内</dd>' +
      '  <dt>店舗住所</dt>' +
      '  <dd>150-8377 東京都渋谷区宇田川町15番1号　渋谷パルコ6F<br>Tokyo Otaku Mode TOKYO</dd>' +
      '  <dt>電話番号</dt>' +
      '  <dd>03-6809-0834</dd>' +
      '  <dt>営業時間</dt>' +
      '  <dd>11時〜21時</dd>' +
      '</dl>' +
      '<p>※開催時期は予告なく変更される可能性があります。また、新型コロナウィルスの影響により、営業時間が変更される場合がございます。ご了承ください。</p>' +
      '<p>　</p>' +
      '<p><em class="is-size-2 is-size-4-mobile">関連リンク</em></p>' +
      '<dl>' +
      '  <dt>販売サイト</dt>' +
      '  <dd>Tokyo Otaku Mode オンラインストア　<a href="https://ja.otakumode.com/" target="_blank" rel="noopener">https://ja.otakumode.com/</a></dd>' +
      '  <dt>Twitter</dt>' +
      '  <dd>Tokyo Otaku Mode Twitter　<a href="https://twitter.com/otakumode_jp" target="_blank" rel="noopener">https://twitter.com/otakumode_jp</a></dd>' +
      '  <dt>Instagram</dt>' +
      '  <dd>Tokyo Otaku Mode Instagram　<a href="https://www.instagram.com/otakumode_jp/" target="_blank" rel="noopener">https://www.instagram.com/otakumode_jp/</a></dd>' +
      '</dl>'
  },
  {
    id: '023',
    date: '2020.09.14',
    title: 'メインPV第4弾（CASE3 PV）公開！',
    description: '9月16日（水）からの【CASE  3：スノー・オブ・ロンドン】TV放送スタートを前に、メインPV第4弾を公開しました！…',
    image: '/assets/images/news-023_s.jpg',
    text:
      '<p>9月16日（水）からの【CASE  3：スノー・オブ・ロンドン】TV放送スタートを前に、メインPV第4弾を公開しました！</p>' +
      '<a href="#010" class="video is-small">' +
      '  <figure><img src="/assets/images/pv-poster10.jpg" alt="メインPV4"></figure>' +
      '</a>' +
      '<p>詐欺師（コンフィデンスマン）たちの新たな標的は、美術界の権威で“世界一の鑑定士”ジェームズ・コールマン（CV：安原義人）。<br>' +
      '2,000万ユーロの価値をもつ名画『ロンドンの雪』をめぐり、美術オークションを舞台にしたスリリングな駆け引きが始まります。</p>' +
      '<p>また、シンシアと画家・トーマス（CV：平川大輔）との過去の恋物語を中心に描かれる、キャラクターの繊細な心の動きにもご注目ください。</p>'
  },
  {
    id: '024',
    date: '2020.09.15',
    title: 'オリジナルサウンドトラックが発売決定！',
    description: 'アニメOP、劇中歌含む豪華2枚組、全35曲約2時間20分による、大ボリューム収録のオリジナルサウンドトラックの発売が決定しました！…',
    image: '/assets/images/no-image_2x.png',
    text:
      '<p>アニメOP、劇中歌含む豪華2枚組、全35曲約2時間20分による、大ボリューム収録のオリジナルサウンドトラックの発売が決定しました！</p>' +
      '<p>映画「キングダム」、TVアニメ「東京喰種トーキョーグール」などを手掛けたやまだ豊による、多彩な楽曲の数々を、ぜひご堪能ください。</p>' +
      '<figure class="is-small"><img src="/assets/images/music-soundtrack.jpg" alt="ジャケット"></figure>' +
      '<dl>' +
      '  <dt>発売日</dt><dd>2020年9月23日(水)</dd>' +
      '  <dt>価格</dt><dd>￥3,000+税</dd>' +
      '  <dt>品番</dt><dd>AZRC-1137-1138</dd>' +
      '</dl>' +
      '<p></p>' +
      '<a href="/music">' +
      '  <button>詳細はこちら</button>' +
      '</a>'
  },
  {
    id: '025',
    date: '2020.09.18',
    title: 'キービジュアル第2弾を公開！',
    description: '9月21日（月）のNetflixでの【CASE 4：ウィザード・オブ・ファー・イースト】配信開始に先立ち、キービジュアル第2弾を公開しました！…',
    image: '/assets/images/news-025_s.jpg',
    text:
      '<p>9月21日（月）のNetflixでの【CASE 4：ウィザード・オブ・ファー・イースト】配信開始に先立ち、キービジュアル第2弾を公開しました！</p>' +
      '<figure class="is-medium"><img src="/assets/images/news-025_l.jpg" alt=""></figure>' +
      '<p>スタリッシュな表情をみせるエダマメとローランを中心に、CASE 4 で登場するキャラクター達が集結します。<br>' +
      '反社会組織をターゲットに、危険な CASE（事件）に挑むエダマメたちの姿と、 謎に包まれてきた ローランの過去の物語がついに明かされます。<br>' +
      'これまでにないクールな表情をみせる、キャラクターにご注目ください！</p>'
  },
  {
    id: '026',
    date: '2020.09.18',
    title: '『コンフィデンスマンJP』より、五十嵐もCASE 4に参戦!?五十嵐役・小手伸也さん、ローラン役・諏訪部順一さんのアフレコ記念写真＆オフィシャルコメントも公開！',
    description: 'ドラマ『コンフィデンスマンJP』ほかで活躍中の俳優・小手伸也さんが、同じく「五十嵐役」としてなんと本作にも登場します。…',
    image: '/assets/images/news-026_s.jpg',
    text:
      '<p>ドラマ『コンフィデンスマンJP』ほかで活躍中の俳優・小手伸也さんが、同じく「五十嵐役」としてなんと本作にも登場します。小手伸也さんと、ローラン役の諏訪部順さん一がCASE4のアフレコに挑む記念写真も公開しました！</p>' +
      '<figure class="is-medium"><img src="/assets/images/news-026-1.jpg" alt=""></figure>' +
      '<figure class="is-medium"><img src="/assets/images/news-026-2.jpg" alt=""></figure>' +
      '<p>また、本人そっくりに描かれたキャラクター設定画と、CASE4登場シーンの先行カットも公開。物語とあわせて、ぜひお楽しみください。</p>' +
      '<figure class="is-medium"><img src="/assets/images/news-026-3.jpg" alt=""></figure>' +
      '<figure class="is-medium"><img src="/assets/images/news-026-4.jpg" alt=""></figure>' +
      '<figure class="is-medium"><img src="/assets/images/news-026-5.jpg" alt=""></figure>' +
      '<p><em>■小手伸也（五十嵐役）オフィシャルコメント</em><br>' +
      '「なんでもローランの野郎がアニメで大活躍してるっていうんで、ちょいと次元の壁を超えて来てやったぜ。奴とは３年前「外見が小手さんで声が諏訪部さん」（当時の偽名だ）という冗談みたいな設定で一心同体だったことがあってな…まぁそんな関係だ。実はコッチも今『仕込み』の真っ最中なんだが、俺のアニメ顔がソッチの役に立つなら、気分転換に力を貸してやるぜ！ってな訳で、以上「神出鬼没がついにココまで！」な五十嵐でした。」</p>' +
      '<p><em>■諏訪部順一（ローラン役）オフィシャルコメント</em><br>' +
      '「CASE４ではいよいよローランの過去が明らかになります。彼がいかにしてコンフィデンスマンとなったのか？心の奥にどのような思いを秘めているのか？そして、メインとなる物語の舞台は東京・上海。これまでにないハードな展開が待ち受けております。今シーズンを締め括るに相応しいフィナーレに御期待下さい！」</p>'
  },
  {
    id: '027',
    date: '2020.09.18',
    title: '【CASE 4：ウィザード・オブ・ファー・イースト】 配信開始キャンペーンを開催！',
    description: '9月21日(月)からのNetflixでのCASE4独占先行配信の開始を記念し、キャンペーンを開催いたします！…',
    image: '/assets/images/no-image_2x.png',
    text:
      '<p>9月21日(月)からのNetflixでのCASE4独占先行配信の開始を記念し、キャンペーンを開催いたします！</p>' +
      '<dl>' +
      '  <dt>期間</dt>' +
      '  <dd>9月18日(金) 18:00～9月27日(日) 23:59</dd>' +
      '  <dt>参加要件</dt>' +
      '  <dd>「#グレプリはいいぞ」のハッシュタグをつけて、アニメ「GREAT PRETENDER」のおすすめコメントをツイート。</dd>' +
      '  <dt>景品</dt>' +
      '  <dd>抽選で100名様に、最新のキービジュアル第2弾のビジュアルを使用した、特製QUOカード1,000円分をプレゼントいたします。<br>' +
      '  ご当選者には、DMにてご連絡いたします。</dd>' +
      '</dl>' +
      '<p class="is-size-5 is-size-6-mobile">※プレゼントの送付先は、日本国内に限らせていただきます。<br>' +
      '※プレゼントの交換、換金および当選権利の譲渡はできません。<br>' +
      '※お預かりした個人情報は厳重に管理を行い、本目的以外に使用いたしません。</p>' +
      '<p>　</p>' +
      '<p>また、本キャンペーンで投稿されたおすすめコメントの一部を、CASE4のTV放送開始時に公開予定の最新PVにハンドルネームとともに掲載させていただく予定です！<br>' +
      '（コメントは抜粋になる場合がございます。あらかじめご了承ください）</p>' +
      '<p>グレプリをお友達やフォロワーさんにぜひお薦めしてください！<br>皆様のご参加をお待ちしております！</p>'
  },
  {
    id: '029',
    date: '2020.10.06',
    title: 'Blu-ray ランダム封入施策「キャスト生サイン入り特製トランプ」追加決定！',
    description: 'インターネットラジオステーション音泉ほかにて好評配信中のWebラジオ『GREAT PRETENDER ～詐欺師の宴～』第二回で出演キャストによるブラックジャック対決を実施！…',
    image: '/assets/images/no-image_2x.png',
    text:
      '<p>インターネットラジオステーション音泉ほかにて好評配信中のWebラジオ『GREAT PRETENDER ～詐欺師の宴～』第二回で出演キャストによるブラックジャック対決を実施！<br>' +
      '番組中で使用された作品特製トランプのうち計17枚に出演者の生サインを入れて、「GREAT PRETENDER Blu-ray CASE 1」にランダム封入いたします！</p>' +
      '<dl>' +
      '  <dt>対象商品</dt>' +
      '  <dd>12月16日(水)発売「GREAT PRETENDER Blu-ray CASE1」</dd>' +
      '  <dt>封入内容</dt>' +
      '  <dd>下記キャストいずれか１名の生サインが入った作品特製トランプ1枚をランダム封入いたします。' +
      '    <ul>' +
      '      <li>枝村真人役／小林千晃</li>' +
      '      <li>ローラン・ティエリー役／諏訪部順一</li>' +
      '      <li>アビゲイル・ジョーンズ役／藤原夏海</li>' +
      '    </ul>' +
      '  </dd>' +
      '</dl>' +
      '<p class="is-size-5 is-size-6-mobile">※生サイン入り特製トランプは12月16日(水)発売のBlu-ray CASE １にランダムで封入されています。<br>' +
      '　ご購入前に中身を確認いただくことはできませんので予めご了承ください。<br>' +
      '※全ての商品にトランプが封入されるわけではございません。</p>' +
      '<figure><img src="/assets/images/news-029_l.jpg" alt=""></figure>' +
      '<p><em>Webラジオ『GREAT PRETENDER ～詐欺師の宴～』第二回<br>' +
      '番組視聴は<a target="_blank" rel="noopener" href="https://www.onsen.ag/program/grepre">コチラ（https://www.onsen.ag/program/grepre）から</a></em></p>'
  },
  {
    id: '031',
    date: '2020.10.10',
    title: '“Someday ft. Emarie” ～シンシアのロンドン物語～ スペシャルMV公開！オリジナルサウンドトラック プライスオフキャンペーンも開催！',
    description: 'ロンドンを舞台にシンシアの過去の恋物語を描いた、【CASE 3：スノー・オブ・ロンドン】完結記念！スペシャルMV “Someday ft. Emarie” ～シンシアのロンドン物語～を公開…',
    image: '/assets/images/news-031_s.jpg',
    text:
      '<p>ロンドンを舞台にシンシアの過去の恋物語を描いた、【CASE 3：スノー・オブ・ロンドン】完結記念！スペシャルMV “Someday ft. Emarie” ～シンシアのロンドン物語～を公開しました！</p>' +
      '<a href="#011" class="video is-small">' +
      '  <figure><img src="/assets/images/pv-poster11.jpg" alt="スペシャルMV"></figure>' +
      '</a>' +
      '<p>オリジナルサウンドトラックの、プライスオフキャンペーンも実施中です！</p>' +
      '<dl>' +
      '  <dt>期間</dt>' +
      '  <dd>10月9日(金)～10月18日(日)　※終了日が遅れる場合がございます。</dd>' +
      '  <dt>対象</dt>' +
      '  <dd>「GREAT PRETENDER」Original Soundtrack 配信販売分</dd>' +
      '  <dt>価格</dt>' +
      '  <dd>' +
      '    Tunes→2100円（税込み2139円）<a target="_blank" rel="noopener" href="https://apple.co/3lwNsP0">https://apple.co/3lwNsP0<a/><br>' +
      '    Amazon→2100円（税込み2310円）<a target="_blank" rel="noopener" href="https://www.amazon.co.jp/dp/B08HV2584V">https://www.amazon.co.jp/dp/B08HV2584V</a><br>' +
      '    ※一部サイトでは価格が異なる場合がございます。' +
      '  </dd>' +
      '</dl>' +
      '<p><em>●商品情報は<a href="/music">こちら（https://www.greatpretender.jp/music）</a>をご覧ください。</em></p>'
  },
  {
    id: '030',
    date: '2020.10.13',
    title: '【CASE 4：ウィザード・オブ・ファー・イースト】フジテレビ「+Ultra」ほか各局放送開始日のお知らせ',
    description: 'TVアニメ「GREAT PRETENDER」は各局一週分放送休止となります。…',
    image: '/assets/images/no-image_2x.png',
    text:
      '<p>TVアニメ「GREAT PRETENDER」は各局一週分放送休止となります。<br>' +
      '【#15 CASE 4_1 ウィザード・オブ・ファー・イースト】は10月21日(水)より、フジテレビ「＋Ultra」ほか各局(関西テレビ/東海テレビ/テレビ西日本/北海道文化放送/BSフジ)にて放送開始となります。</p>' +
      '<p><em>【#15 CASE 4_1 ウィザード・オブ・ファー・イースト 放送日】</em></p>' +
      '<p><em>フジテレビ　10月21日(水) 24:55〜25:25　※10月14日(水)放送休止<br>' +
      '関西テレビ　10月22日(木) 25:55〜26:25　※10月15日(木)放送休止<br>' +
      '東海テレビ　10月24日(土) 25:45〜26:15　※10月17日(土)放送休止<br>' +
      'テレビ西日本　10月21日(水) 25:55〜26:25　※10月14日(水)放送休止<br>' +
      '北海道文化放送　10月25日(日) 25:10〜25:40　※10月18日(日)放送休止<br>' +
      'BSフジ　10月28日(水) 24:00〜24:30　※10月21日(水)放送休止</em></p>'
  },
  {
    id: '032',
    date: '2020.10.19',
    title: 'メインPV第5弾（CASE 4 PV）公開！',
    description: '10月21日（水）からの【CASE 4：ウィザード・オブ・ファー・イースト】TV放送スタートを前に、メインPV第5弾を公開しました！…',
    image: '/assets/images/news-032_sa.jpg',
    text:
      '<p>10月21日（水）からの【CASE 4：ウィザード・オブ・ファー・イースト】TV放送スタートを前に、メインPV第5弾を公開しました！</p>' +
      '<a href="#012" class="video is-small">' +
      '  <figure><img src="/assets/images/pv-poster12a.jpg" alt="メインPV5"></figure>' +
      '</a>' +
      '<p>今回のターゲットは、東京・上海の組織で、裏社会の女帝・朱雀アケミ（CV：高島雅羅）と上海マフィアのドン・劉暁（CV：坂口周平、瞳音）。さらに、“魔法使い”と呼ばれる謎の男・オズ（CV：咲野俊介）も登場し、2つの都市を舞台にした、組織の対立を描く危険なコンゲームが始まります。<br>' +
      'また、これまで謎に包まれてきたローランの過去もついに明らかに！<br>' +
      'ローランが愛した女性、ドロシー（CV：小松由佳）の存在を中心に、過去から現在までを結ぶ壮大な物語をお見逃しなく！</p>'
  },
  {
    id: '033',
    date: '2020.10.21',
    title: '壮大な物語の誕生秘話を語る！古沢良太（脚本・シリーズ構成）オフィシャルインタビュー公開！',
    description: 'いよいよ本日10月21日（水）よりフジテレビ「＋Ultra」ほか各局(関西テレビ/東海テレビ/テレビ西日本/北海道文化放送/BSフジ)にて…',
    image: '/assets/images/no-image_2x.png',
    text:
      '<p>いよいよ本日10月21日（水）よりフジテレビ「＋Ultra」ほか各局(関西テレビ/東海テレビ/テレビ西日本/北海道文化放送/BSフジ)にて、【CASE 4：ウィザード・オブ・ファー・イースト（極東の魔法使い）】が放送開始！' +
      '『GRETA PRETENDER』の集大成たるCASE 4をさらに楽しむための手掛かりとして、脚本・シリーズ構成の古沢良太のインタビューが到着！ぜひご覧ください！</p>' +
      '<a href="/special/interview01">' +
      '  <button>インタビューはこちら</button>' +
      '</a>'
  },
  {
    id: '034',
    date: '2020.10.22',
    title: 'フジテレビアニメラインナップ発表会2020配信決定！スタッフ・キャスト陣によるトークパートも！',
    description: 'フジテレビアニメラインナップ発表会2020にて、 “ノイタミナ”、「＋Ultra」の新作・新情報一挙解禁！「GREAT PRETENDER」トークパートでは…',
    image: '/assets/images/no-image_2x.png',
    text:
      '<p>フジテレビアニメラインナップ発表会2020にて、 “ノイタミナ”、「＋Ultra」の新作・新情報一挙解禁！<br>' +
      '「GREAT PRETENDER」トークパートでは古沢良太さん(脚本・シリーズ構成)/小林千晃さん(枝村真人役)/諏訪部順一さん(ローラン・ティエリー役)もご登場です！</p>' +
      '<dl>' +
      '  <dt>日時</dt>' +
      '  <dd>2020年11月5日（木）20：00～配信<br><span class="has-text-weight-normal">※映像は事前に収録したものとなります。<br>※アーカイブ配信は11月15日（日）23:59まで</span></dd>' +
      '  <dt>配信サイト</dt>' +
      '  <dd>' +
      '    <a target="_blank" rel="noopener" href="https://youtu.be/h_JIW291YNw">YouTube （配信・アーカイブ配信）　https://youtu.be/h_JIW291YNw</a><br>' +
      '    <a target="_blank" rel="noopener" href="https://www.pscp.tv/noitamina2010">Periscope （配信）　https://www.pscp.tv/noitamina2010</a><br>' +
      '    <a target="_blank" rel="noopener" href="https://fod.fujitv.co.jp/s/genre/anime/ser5f57">FOD/TVer （アーカイブ配信）　https://fod.fujitv.co.jp/s/genre/anime/ser5f57</a>' +
      '  </dd>' +
      '  <dt>トークパートゲスト</dt>' +
      '  <dd>古沢良太さん(脚本・シリーズ構成)/小林千晃さん(枝村真人役)/諏訪部順一さん(ローラン・ティエリー役)</dd>' +
      '</dl>' +
      '<p><em>フジテレビアニメラインアップ発表会詳細は<a target="_blank" rel="noopener" href="https://noitamina.tv/lineup/2020">こちら　https://noitamina.tv/lineup/2020</a></em></p>'
  },
  {
    id: '028',
    date: '2020.10.27',
    title: 'HMV3店舗にてポップアップショップ開催決定！（博多・心斎橋開催情報追加）',
    description: 'HMV&BOOKSにてポップアップショップの開催が決定！渋谷店・博多店・心斎橋店を巡回いたします。…',
    image: '/assets/images/news-028_sb.jpg',
    text:
      '<figure><img src="/assets/images/news-028-1_b.jpg" alt=""></figure>' +
      '<p>HMV&BOOKSにてポップアップショップの開催が決定！渋谷店・博多店・心斎橋店を巡回いたします。</p>' +
      '<p>店内には描き下ろしイラストのパネルや『制作資料展』で展示されたキャラクター設定・「Case1:Los Angeles Connection」の原画もご用意しております。<br>' +
      '※展示する制作資料は複製物となります。<br>' +
      'HMVポップアップショップ限定の描き下ろしイラストを使用したオリジナルグッズの販売も行います。購入特典として、2,000円（税抜）お買い上げごとにポストカード1枚（ランダム全4種）をプレゼントいたします。</p>' +
      '<figure><img src="/assets/images/news-028-2_b.jpg" alt=""></figure>' +
      '<p>ポップアップストアにて販売される商品は事後通販を予定しております。詳細は後日HMVアニメ！Twitter（<a target="_blank" rel="noopener" href="https://twitter.com/HMV_Anime">@HMV_Anime</a>）にて詳細をお伝えいたします。</p>' +
      '<dl>' +
      '  <dt>期間</dt>' +
      '  <dd>' +
      '    渋谷 ： 2020年10月9日（金）～2020年10月20日（火）<br>' +
      '    博多 ： 2020年10月29日（木）～2020年11月15日（日）<br>' +
      '    心斎橋 ： 2020年11月20日（金）～2020年12月6日（日）' +
      '  </dd>' +
      '  <dt>場所</dt>' +
      '  <dd>' +
      '    HMV&BOOKS SHIBUYA 5F特設スペース　<a target="_blank" rel="noopener" href="https://www.hmv.co.jp/store/BTK/">https://www.hmv.co.jp/store/BTK/</a><br>' +
      '    HMV&BOOKS HAKATA　<a target="_blank" rel="noopener" href="https://www.hmv.co.jp/store/BHK/">https://www.hmv.co.jp/store/BHK/</a><br>' +
      '    HMV&BOOKS SHINSAIBASHI　<a target="_blank" rel="noopener" href="https://www.hmv.co.jp/store/BSB/">https://www.hmv.co.jp/store/BSB/<a>' +
      '  </dd>' +
      '</dl>' +
      '<p class="is-size-5 is-size-6-mobile">※開催時期は予告なく変更される可能性があります。また、新型コロナウィルスの影響により、営業時間が変更される場合がございます。ご了承ください。</p>'
  },
  {
    id: '035',
    date: '2020.10.30',
    title: 'アニメイト×TVアニメ『GREAT PRETENDER』Blu-ray 発売記念抽選会',
    description: 'TVアニメ『GREAT PRETENDER』Blu-ray　CASE１の発売を記念して、アニメイトオンラインショップとアニメイト秋葉原本館にて抽選会の開催が決定いたしました！…',
    image: '/assets/images/no-image_2x.png',
    text:
      '<p>TVアニメ『GREAT PRETENDER』Blu-ray　CASE１の発売を記念して、アニメイトオンラインショップとアニメイト秋葉原本館にて抽選会の開催が決定いたしました！<br>' +
      '期間中、対象商品を1点お買い上げいいただきますと、1回抽選会にご参加できます。<br>' +
      '当たった方にはサイン入り豪華景品をプレゼント！</p>' +
      '<p>　</p>' +
      '<dl>' +
      '  <dt>場所</dt>' +
      '  <dd>アニメイトオンラインショップ、アニメイト秋葉原本館</dd>' +
      '  <dt>期間</dt>' +
      '  <dd>2020年12月15日（火）～2020年12月27日（日）</dd>' +
      '  <dt>景品内容</dt>' +
      '  <dd>' +
      '    ・サイン入り宣伝B2ポスター …10名様<br>' +
      '    <span class="is-size-5 is-size-6-mobile has-text-weight-normal">(監督：鏑木ひろ、脚本・シリーズ構成：古沢良太、サブキャラクターデザイン・総作画監督：加藤寛崇、枝村真人役：小林千晃、ローラン・ティエリー役：諏訪部順一)</span><br>' +
      '    ・サイン入りアフレコ台本 …3名様<br>' +
      '    <span class="is-size-5 is-size-6-mobile has-text-weight-normal">(監督：鏑木ひろ、脚本・シリーズ構成：古沢良太、枝村真人役：小林千晃、ローラン・ティエリー役：諏訪部順一)</span>' +
      '  </dd>' +
      '  <dt>対象商品</dt>' +
      '  <dd>2020 年12月16 日(水) 発売<br>「GREAT PRETENDER」CASE 1 ロサンゼルス・コネクション（品番：TBR31041D）</dd>' +
      '</dl>' +
      '<p>　</p>' +
      '<p class="is-size-5 is-size-6-mobile">' +
      '  ※景品の内容や店頭販売の開催日程などは変更になる場合がございます。予めご了承ください。<br>' +
      '  ※数量限定のため、無くなり次第終了となります。<br>' +
      '  ※開催期間中にご参加ください。開催期間後のご参加は無効となりますので、予めご了承ください。<br>' +
      '  ※状況により、抽選会への回数制限を設けさせていただく場合がございます。<br>' +
      '  ※抽選会にご参加いただけるのは、開催店舗で対象商品を購入した方に限ります。<br>' +
      '  ※既に対象店舗で対象商品をご予約いただいている方も、開催期間中の商品引き取り時に抽選会にご参加いただけます。<br>' +
      '  ※通販は施策概要が異なりますため、詳しくは通販サイトをご確認ください。<br>' +
      '  ※景品のオークションでの転売を禁じます。発覚した場合は厳正なる対応をさせていただきます。<br>' +
      '  ※景品残数等に関するお問い合わせはお答え出来かねます。<br>' +
      '  ※景品の代替品等はございませんので、交換対応はいたしかねます。予め、ご了承ください。<br>' +
      '  ※景品の傷・破損などによる交換はいたしかねますので、予めご了承ください。<br>' +
      '  ※転売行為防止の為、景品の裏にお客様のお名前を入れさせていただく場合がございます。<br>' +
      '  ※施策に関わる景品・特典・サイン本他・応募券・引換券等は、全て第三者への譲渡・オークション等の転売は禁止とさせていただきます。' +
      '</p>' +
      '<p>　</p>' +
      '<p><em><a target="_blank" rel="noopener" href="https://www.animate-onlineshop.jp/contents/fair_event/detail.php?id=104658">詳しくはこちら　https://www.animate-onlineshop.jp/contents/fair_event/detail.php?id=104658</a></em></p>'
  },
  {
    id: '036',
    date: '2020.12.14',
    title: '最終話放送記念3大キャンペーン開催決定！',
    description: '12月16日(水)より、フジテレビ「+Ultra」ほか各局にて放送となる最終回に合わせ、3大キャンペーンの開催が決定しました！TV放送と合わせ、お楽しみに！…',
    image: '/assets/images/no-image_2x.png',
    text:
      '<p>12月16日(水)より、フジテレビ「+Ultra」ほか各局にて放送となる最終回に合わせ、3大キャンペーンの開催が決定しました！TV放送と合わせ、お楽しみに！</p>' +
      '<p><em>① 総額100万円山分け！最終回直前セリフ当てクイズ！</em><br>' +
      'Twitterで @GrePre_animeをフォロー頂き、対象ツイートのクイズにチャレンジ！回答をツイートしてください！正解した方の中から、抽選で10名様に商品券10万円をプレゼント！<br>' +
      '皆様のご参加、お待ちしております！<br>' +
      '(対象ツイート：<a target="_blank" rel="noopener" href="https://twitter.com/GrePre_anime/status/1338410132993056768">https://twitter.com/GrePre_anime/status/1338410132993056768</a>)' +
      '</p>' +
      '<dl>' +
      '  <dt>期間</dt>' +
      '  <dd>12月14日(月)18:00～12月24日(木)23:59まで</dd>' +
      '  <dt>応募要件</dt>' +
      '  <dd>・日本国内に在住の方<br>・2020年12月14日(月)時点で、満20歳以上の方</dd>' +
      '</dl>' +
      '<p><em>② 最終話感想募集キャンペーン！</em><br>' +
      'グレプリの感想を「#グレプリはいいぞ」をつけてツイートしてください！あなたのコメントが、ホームページ上で紹介されるかも⁉是非ご参加ください！<br>' +
      'また、放送終了後、最終話感謝イラストカードデータの配布も決定！是非ダウンロードしてお楽しみください！</p>' +
      '<p><em>③ WEBラジオ最終回配信決定！</em><br>' +
      'WEBラジオ「GREAT PRETENDER～詐欺師（コンフィデンスマン）の宴～」もいよいよ最終回！<br>' +
      '「#グレプリはいいぞ」をつけてツイートいただいた投稿も一部紹介予定です！配信日は後日発表！お楽しみに！</p>' +
      '<p class="is-size-5 is-size-6-mobile">＜個人情報取り扱いについて＞<br>' +
      '・ご提供いただく個人情報は、個人情報の保護に関する法律ならびにこれに関連する法令およびガイドライン等を遵守し（東宝株式会社　個人情報保護ポリシー（<a target="_blank" rel="noopener" href="https://www.toho.co.jp/company/privacy-policy.html">https://www.toho.co.jp/company/privacy-policy.html</a>））、細心の注意を払ってお取扱いいたします。<br>' +
      '・ご提供いただく個人情報は、賞品送付および賞品送付に伴うご連絡のためにのみ利用いたします。<br>' +
      '・ご提供いただく個人情報は東宝株式会社が責任をもって管理いたしますとともに、抽選の終了後、保有を継続する必要がなくなった場合は適切な方法により消去し、または記録された媒体を安全な方法で廃棄いたします。<br>' +
      '</p>'
  },
  {
    id: '037',
    date: '2021.03.24',
    title: '生バンド演奏でおくる 音楽劇「GREAT PRETENDER グレートプリテンダー」、宮田俊哉主演で上演決定！',
    description: '2021年7月に東京・東京建物 Brillia HALL、8月に大阪・オリックス劇場にて、音楽劇「GREAT PRETENDER グレートプリテンダー」を宮田俊哉主演で上演することが…',
    image: '/assets/images/news-037_s.jpg',
    text:
      '<figure><img src="/assets/images/news-037_l.jpg" alt=""></figure>' +
      '<p>2021年7月に東京・東京建物 Brillia HALL、8月に大阪・オリックス劇場にて、音楽劇「GREAT PRETENDER グレートプリテンダー」を宮田俊哉主演で上演することが決定いたしました！<br>' +
      '初の舞台化となる今回の物語は、CASE 1：ロサンゼルス・コネクションをベースに構成。そして、生バンドによる演奏でさらに疾走感あふれる、痛快クライム・エンタテイメントが誕生します！</p>' +
      '<p>この度の舞台化で主演を務めるのは、旺盛なサービス精神と朗らかな笑顔、そしてアニメを心から愛するKis-My-Ft2の宮田俊哉。ライブのほか、バラエティや情報番組、ラジオ番組のレギュラー出演など幅広く活動しており、2013年の舞台「キフシャム国の冒険」で舞台単独初主演を務めました。久しぶりの舞台単独主演となる本作で、主人公の枝村真人、通称エダマメを演じます。 “日本一の天才詐欺師”を自称するエダマメは、その実、真面目でお人好し。宮田が音楽劇として体現するエダマメをどうぞお楽しみに！</p>' +
      '<p>そして演出は、ストレートプレイやミュージカル、音楽劇とジャンルを問わず活躍する演劇界の奇才、河原雅彦が手掛けます。テンポ良いきらびやかな演出の中にも、ほのかなメランコリックを忍ばせる河原の多彩な演出マジックとの化学反応、どうぞご期待ください。</p>' +
      '<p><em>音楽劇『GREAT PRETENDER　グレートプリテンダー』公式サイト<br>' +
      '<a href="https://www.greatpretender-stage.jp/" target="_blank" rel="noopener">greatpretender-stage.jp</a></em></p>' +
      '<br>' +
      '<p><em>主演：宮田俊哉　コメント</em></p>' +
      '<p>今回のお話をいただいて、とても嬉しく思っています。舞台の主演を一人で務めるのはすごく久しぶりで、一人で背負うのでドキドキしていますが、舞台は観に行くのも自分が演じるのも好きなので、本当に楽しみです。<br>' +
      '原作の「GREAT PRETENDER」は、面白くてワクワクするところがとても好きで、僕が『面白いよ！』と勧めた友人達と皆で、ハマりました。出演のお話を伺ったとき、『僕、ローランじゃないの!?』とボケてしまいましたが(笑)、エダマメをやらせていただけるのは光栄です！エダマメは、ちゃんと芯があるな、と思います。心のある人物で、良心を感じます。物事を、“良いか悪いか”ではなく、“目の前の相手に対して、親切かどうか”というのが判断の基準になっているような、印象があります。僕も似たところがあるので、とても共感できます。あとはグループ内での立ち位置が似ていますね。僕もメンバーによくいじられるので(笑)。<br>' +
      'このコロナ禍で、ファンの皆さまと中々お会いできていないので、この舞台でお会いできるのが本当に楽しみです。原作ファンの方にも、楽しんでいただけるよう、精一杯頑張ります！</今回のお話をいただいて、とても嬉しく思っています。舞台の主演を一人で務めるのはすごく久しぶりで、一人で背負うのでドキドキしていますが、舞台は観に行くのも自分が演じるのも好きなので、本当に楽しみです。>' +
      '<p class="is-size-5 is-size-6-mobile">プロフィール<br>' +
      '2011年2月、Kis-My-Ft2としてCDデビュー。グループとして、また派生ユニット・舞祭組としての音楽活動、さらに舞台・TVドラマ・映画など幅広く活躍し、バラエティでは筋金入りの“アニメファン”として注目を集める。近年の主な出演作に、【舞台】「○○な人の末路～僕たちの選んだ××な選択～」(20)、【TVドラマ】「○○な人の末路」(18・NTV／主演)、「やすらぎの刻～道」(19・EX)、「真夏の少年～19452020」(20・EX)、【WEBドラマ】「BE LOVE」(20・dTV／主演・脚本監修)、【アニメ】「劇場版BEM〜BECOME HUMAN〜」(20)など。現在、【TV】「アサデス。」火曜レギュラー(KBC)、「10 万円でできるかな」(EX)、「キスマイ超BUSAIKU!?」(CX)、「中居正広のニュースな会」(EX)、「もしもツアーズ」(CX)、「ザ少年倶楽部プレミアム」(NHKBS プレミアム)、【ラジオ】「燃(萌)えよ！ラジオ」(FM ヨコハマ)、「Kis-My-Ft2 キスマイRadio」(文化放送)、「Kis-My-Ft2 のオールナイトニッポンPremium」(ニッポン放送)に出演中。21 年4 月からドラマ「華麗なる一族」(WOWOW)に出演を控える。</p>' +
      '<br>' +
      '<p><em>演出：河原雅彦　コメント</em><br>' +
      '騙し騙されの応酬が飛び交うこの作品は、いわゆる“コンゲームもの”で、どっちに話が転ぶか分からないスリリングな展開が魅力。そんな場合、一番の肝は登場人物たちのキャラクターに尽きるわけですよ。宮田くんとは初めてのお仕事になりますけど、『日本一を自称するも、てんてこ舞いに振り回されるダメダメな詐欺師』って主人公にピッタリのような気がして。あ、これ別にディスリじゃないですよ？主人公のエダマメは、キめるところはビシっとキめるし。<br>' +
      '僕がアニメ原作を舞台化する際、常に心掛けていることは、演劇の強みを最大限に活かすこと。ストーリーをなぞるだけじゃ意味ないですからね。今回の舞台化にあたっても、舞台オリジナルの重要な役どころを足させてもらったり。ミュージカル要素までちょっぴり足させてもらいました。欲張りすぎですかね？？<br>' +
      'ま、ちょっとやってみます。</p>' +
      '<p class="is-size-5 is-size-6-mobile">プロフィール<br>' +
      '俳優・演出家・脚本家。演劇やライブ活動を行う「HIGHLEG JESUS」を1992年に結成し総代を務め、2002年の解散まで全ての作品の作・演出を手掛ける。06年にシス・カンパニー公演「父帰る／屋上の狂人」の演出で第14回読売演劇大賞・優秀演出家賞を、15年にパルコ・プロデュース「万獣こわい」の演出で第22回読売演劇大賞・優秀作品賞を受賞。近年の主な演出作品に、「ロッキー・ホラー・ショー」「魔都夜曲」「人間風車」(17)、「偽伝写楽2018」「歌喜劇／市場三郎～グアムの恋」(18)、愛のレキシアター「ざ・びぎにんぐ・おぶ・らぶ」(19/原案・演出・上演台本)、「オリエント急行殺人事件」(19・20)、“ねずみの三銃士”第4回企画公演「獣道一直線!!!」(20)など。</p>'
  },
  {
    id: '038',
    date: '2021.04.08',
    title: '生バンド演奏でおくる音楽劇「GREAT PRETENDER グレートプリテンダー」、全キャストと公演情報が解禁！',
    description: '生バンド演奏でおくる音楽劇。宮田俊哉をはじめ豪華キャストが競演！…',
    image: '/assets/images/news-037_s.jpg',
    text:
      '<figure><img src="/assets/images/news-037_l.jpg" alt=""></figure>' +
      '<p><em>生バンド演奏でおくる音楽劇。宮田俊哉をはじめ豪華キャストが競演！</em></p>' +
      '<p>“日本一の天才詐欺師”を自称するも、その実、真面目でお人好しな主人公・枝村真人、通称エダマメを演じるのは、筋金入りのアニメファンとしても親しまれるKis-My-Ft2の宮田俊哉。原作にも放送時ハマっていたというアニメ愛あふれる宮田が、約8年ぶりに舞台単独主演を務めます。<br>' +
      'アニメ1話から5話で描かれる物語、CASE1：ロサンゼルス・コネクションをベースに構成される本作に、豪華キャストが集結！<br>' +
      'エダマメが行動を共にすることになるフランス人の信用詐欺師(コンフィデンスマン)ローラン・ティエリー役に、元宝塚歌劇団男役スターの美弥るりか。磨き抜かれた演技力と色香に満ちた美貌で数多のファンを虜にしてきた美弥の、新たなハマり役となることでしょう。<br>' +
      '舞台版オリジナルキャラクター・北大路役に、ユニークなキャラクターと子役時代から培われた演技力で舞台やTVドラマ、映画、バラエティとマルチに活躍する加藤諒。そして、しなやかで引き締まった体躯と抜群の運動能力をもつ信用詐欺師(コンフィデンスウーマン)アビゲイル・ジョーンズ（アビー）役に、中国武術を幼少期から極め、槍術では世界大会優勝経験もある女優・山本千尋、美しく知的なFBI敏腕捜査官ポーラ・ディキンス役に、元宝塚歌劇団トップ娘役で実力派として知られる仙名彩世。また、劇団ラッパ屋などの舞台やTVドラマで幅広く活躍を続ける福本伸一、唯一無二の存在感でジャンルを問わず硬軟様々な作品に引っ張りだこの平田敦子、さらに、劇団M.O.P.作品をはじめ多数の舞台、「踊る大捜査線」シリーズなど映像分野でも広く活躍する三上市朗、舞台を中心に多彩な作品で活躍する傍ら、舞台演出も多数手がけ、映画やTVドラマでも芯ある存在感で作品を引き締める大谷亮介といった、多彩な実力派キャストが揃います。<br>' +
      '生バンド演奏でおくる疾走感あふれる音楽劇「GREAT PRETENDER グレートプリテンダー」に、どうぞご期待ください！</p>' +
      '<br>' +
      '<p><em>出演</em></p>' +
      '<p>宮田俊哉 as 枝村真人(エダマメ)<br>' +
      '美弥るりか as ローラン・ティエリー<br>' +
      '加藤諒 as 北大路<br>' +
      '山本千尋 as アビゲイル・ジョーンズ(アビー)</p>' +
      '<p>庄司ゆらの　前田悟<br>' +
      '伽藍琳　小島亜莉沙　大澤えりな　吉田繭　當真一嘉<br>' +
      '安福毅　横沢健司　穴沢裕介　真鍋恭輔　辺田友文　岡野一平　黒沼亮　工藤翔馬</p>' +
      '<p>仙名彩世 as ポーラ・ディキンス<br>' +
      '福本伸一 as 工藤<br>' +
      '平田敦子 as キム・シウォン<br>' +
      '三上市朗 as サラザール<br>' +
      '大谷亮介 as エディ・カッサーノ</p>' +
      '<br>' +
      '<p><em>チケット発売</em><br>' +
      '6月12日（土） AM10：00～<br>' +
      '<p><em>【東京公演】　2021年7月4日(日)～25日(日)　会場：東京建物 Brillia HALL</em><br>' +
      'チケット料金 S席 12,000円　　A席 9,000円（全席指定・税込/未就学児入場不可）<br>' +
      '<p><em>【大阪公演】　2021年8月4日(水)～8日(日)　会場：オリックス劇場</em><br>' +
      'チケット料金 S席 12,000円　　A席 9,000円　　B席 6,000円（全席指定・税込）<br>' +
      '<p><em>主催</em><br>' +
      'フジテレビジョン　サンライズプロモーション東京</p>' +
      '<p><em>詳細は、音楽劇『GREAT PRETENDER　グレートプリテンダー』公式サイトへ！<br> ' +
      '<a href="https://www.greatpretender-stage.jp/" target="_blank" rel="noopener">greatpretender-stage.jp</a></em></p>'
  },
  {
    id: '039',
    date: '2021.06.10',
    title: '音楽劇「GREAT PRETENDER  グレートプリテンダー」キービジュアル公開！チケット一般発売6月12日スタート！',
    description: 'Kis-My-Ft2の宮田俊哉が主演を務める音楽劇「GREAT PRETENDER  グレートプリテンダー」のキービジュアルが公開されました！',
    image: '/assets/images/news-039_s.jpg',
    text:
      '<figure oncontextmenu="return false;" ><img style="pointer-events: none; touch-callout: none; user-select: none;" src="/assets/images/news-039_l.jpg" alt=""></figure>' +
      '<p>Kis-My-Ft2の宮田俊哉が主演を務める音楽劇「GREAT PRETENDER  グレートプリテンダー」のキービジュアルが公開されました！<br>' +
      '宮田俊哉扮する枝村真人（エダマメ）、美弥るりか扮するローラン・ティエリー、加藤諒扮する音楽劇オリジナルキャラクターの北大路をはじめとするメインキャスト9名が勢揃いしたビジュアルとなっています。<br>' +
      '併せてチケットの一般発売を2021年6月12日(土)10:00より開始いたします！<br>' +
      '本作は、2021年7月4日(日)から7月25日(日)まで東京・東京建物 Brillia HALL、2021年8月4日(水)から8月8日(日)まで大阪・オリックス劇場にて公演いたします。<br>' +
      '<p><em>詳細は、音楽劇『GREAT PRETENDER　グレートプリテンダー』公式サイトへ！<br> ' +
      '<a href="https://www.greatpretender-stage.jp/" target="_blank" rel="noopener">greatpretender-stage.jp</a></em></p>' +
      '<br>' +
      '<p><em>出演</em></p>' +
      '<p>宮田俊哉 as 枝村真人(エダマメ)<br>' +
      '美弥るりか as ローラン・ティエリー<br>' +
      '加藤諒 as 北大路<br>' +
      '山本千尋 as アビゲイル・ジョーンズ(アビー)</p>' +
      '<p>庄司ゆらの　前田悟<br>' +
      '伽藍琳　小島亜莉沙　大澤えりな　吉田繭　當真一嘉<br>' +
      '安福毅　横沢健司　穴沢裕介　真鍋恭輔　辺田友文　岡野一平　黒沼亮　工藤翔馬</p>' +
      '<p>仙名彩世 as ポーラ・ディキンス<br>' +
      '福本伸一 as 工藤<br>' +
      '平田敦子 as キム・シウォン<br>' +
      '三上市朗 as サラザール<br>' +
      '大谷亮介 as エディ・カッサーノ</p>' +
      '<br>' +
      '<p><em>チケット発売</em><br>' +
      '6月12日（土） AM10：00～<br>' +
      '<p><em>【東京公演】　2021年7月4日(日)～25日(日)　会場：東京建物 Brillia HALL</em><br>' +
      'チケット料金 S席 12,000円　　A席 9,000円（全席指定・税込/未就学児入場不可）<br>' +
      '<p><em>【大阪公演】　2021年8月4日(水)～8日(日)　会場：オリックス劇場</em><br>' +
      'チケット料金 S席 12,000円　　A席 9,000円　　B席 6,000円（全席指定・税込）<br>' +
      '<br>' +
      '<p><em class="is-size-2 is-size-4-mobile">主催</em></p>' +
      '<p><em>企画</em><br>' +
      'フジテレビジョン<br>' +
      '<em>製作</em><br>' +
      'フジテレビジョン　サンライズプロモーション東京<br>' +
      '<em>主催</em><br>' +
      'フジテレビジョン　サンライズプロモーション東京　（東京公演）<br>' +
      '関西テレビ放送　サンライズプロモーション東京　（大阪公演）</p>'
  },
  {
    id: '040',
    date: '2023.11.17',
    title: 'GREAT PRETENDER razbliuto （ラズブリウト）全世界展開決定!',
    description: '2020年、フジテレビ「+Ultra」ほかにて放送されたオリジナルアニメ『GREAT PRETENDER』（読み：グレート プリテンダー）は、自称“日本一の天才詐欺師…',
    image: '/assets/images/news-040_s.jpg',
    text:
      '<figure oncontextmenu="return false;" ><img style="pointer-events: none; touch-callout: none; user-select: none;" src="/assets/images/news-040_l.jpg" alt=""></figure>' +
      '<p>2020年、フジテレビ「+Ultra」ほかにて放送されたオリジナルアニメ『GREAT PRETENDER』（読み：グレート プリテンダー）は、自称“日本一の天才詐欺師”枝村真人（えだむら まこと）が、悪人のみを標的とした天才詐欺師ローラン・ティエリーと出会ったことで世界を股に掛けたコンゲーム巻き込まれていく痛快クライムエンタテインメントです。本作は全世界で配信され、目の回るよう名駆け引きと見るものを欺く巧妙なシナリオ、そして日本屈指のアニメ制作会社WIT STUDIOによる圧倒的な映像により、日本のみならず世界中で高い評価を獲得し、続編を望む声が寄せられていました。その『GREAT PRETENDER』の続報が遂に到着！<br>' +
      '2024年、全世界に向けて新作を展開いたします！</p>' +
      '<p>日本国内 では DMM TVが独占コンテンツとして展開！<br>' +
      '中東16カ国 ではサウジアラビアのコンテンツ企業Manga Productionsがマスターライセンシーとし作品展開を実施！<br>' +
      'その他全世界※ は、世界最大級のアニメコレクションを200以上の国と地域で展開する企業クランチロールが運用！<br>' +
      ' ※中国本土を除く<br>' +
      '世界中の国と地域で本作をお楽しみいただけます。</p>' +
      '<p><em>世界最速 ！冒頭20分超先行上映／Anime NYC 2023</em><br>' +
      '全世界展開に先駆け、2023年11月18日(土)、米・ニューヨークで開催される世界最大規模のコンベンション「Anime NYC 2023」内で最新情報発表パネルを実施！監督・鏑木ひろ、WIT STUDIO代表 和田丈嗣、製作プロデューサー・伊藤整が登壇し、本作についてのトークを行います。またこのパネル内では本作冒頭20分を世界最速！超先行上映を致します。是非現地へお運びください！</p>' +
      '<p><em>新作カットによるPV映像完成！加藤寛崇によるキービジュアル到着！</em><br>' +
      'また本日公開となった、新作カットによるPV映像も到着。『GREAT PRETENDER』CASE 4 ウィザード・オブ・ファー・イーストで登場した、ローランをコンフィデンスマンの世界に誘ったコンフィデンスレディの姿はもちろん、新キャラクターたちの姿がご覧いただけます</p>'
  },
  {
    id: '041',
    date: '2023.11.21',
    title: '世界最速の本編上映（冒頭20分）も決行！Anime NYC 2023パネルイベントレポート',
    description: '2023年11月18日(土)現地時間12時45分より、アメリカ・ニューヨークで開催されたアニメコンベンション「Anime NYC 2023」にて、『GREAT PRETENDER razbliuto』…',
    image: '/assets/images/news-041_s.jpg',
    text:
      '<p>2023年11月18日(土)現地時間12時45分より、アメリカ・ニューヨークで開催されたアニメコンベンション「Anime NYC 2023」にて、『GREAT PRETENDER razbliuto』（グレートプリテンダー ラズブリウト）のパネルが行われ、監督の鏑木ひろ、WIT STUDIO代表取締役社長の和田丈嗣、製作プロデューサーを務めるProduction I.Gの伊藤整が登壇、約1,000人のファンを前に作品の最新情報発表と『GREAT PRETENDER razbliuto』本編の冒頭20分世界最速上映を行いました。</p>' +
      '<figure oncontextmenu="return false;" style="margin-bottom: 0;">' +
      '<img style="pointer-events: none; touch-callout: none; user-select: none;" src="/assets/images/news-041-1_l.jpg" alt="">' +
      '</figure>' +
      '<p class="is-size-6 is-size-6-mobile" style="margin-bottom: 2rem;">※左から、Production I.G伊藤プロデューサー、鏑木ひろ監督、WIT STUDIO和田代表</p>' +
      '<p>11月17日（金）に解禁された、続編決定の速報を受け、ニューヨークに集うファンたちがパネル会場に殺到。立ち見客も発生する満員御礼。席に座れないファンたちが壁際で立ち見をするなか、伊藤プロデューサー、和田丈嗣代表、そして鏑木ひろ監督が登壇。</p>' +
      '<figure oncontextmenu="return false;" style="margin-bottom: 0;">' +
      '<img style="pointer-events: none; touch-callout: none; user-select: none;" src="/assets/images/news-041-2_l.jpg" alt="">' +
      '</figure>' +
      '<p>会場のファンに向けて挨拶をし、17日（金）に解禁となった最新PVとキャラクターデザインを務める加藤寛崇によるキービジュアルを披露。続いて、本イベントが世界最速公開となる本編映像冒頭20分の上映がスタート。画面にコンフィデンスレディ・ドロシーの姿が映ると、会場からは大きな歓声があがりました。新キャラクターたちが続々と登場する本編は『グレプリ』らしいコミカルなシーンも多く、会場はファンの笑い声に溢れました。</p>' +
      '<p>上映終了後には、鏑木ひろ監督がキャラクターについて紹介を行い、ドロシーの新デザイン、キービジュアルにも登場する新キャラクターたち、そして枝村真人について紹介いたしました。</p>' +
      '<figure oncontextmenu="return false;" style="margin-bottom: 0;">' +
      '<img style="pointer-events: none; touch-callout: none; user-select: none;" src="/assets/images/news-041-3_l.jpg" alt="">' +
      '</figure>' +
      '<p>告知コーナーでは伊藤プロデューサーから作品の今後の展開について発表があり、日本ではDMM TV独占展開であること、中東および北アフリカ地域ではマンガプロダクションズが展開することを説明。そしてその他全世界を、クランチロールが展開し、さらには北アメリカ地域で同社による劇場展開が行われることが発表され、会場は歓喜に包まれました。</p>' +
      '<p>最後に、ファンからのQ&Aやじゃんけん大会、そして会場のファンたちと一緒に集合写真を撮影するなど、ファンとの交流を深めつつパネルは終了いたしました。</p>' +
      '<figure oncontextmenu="return false;" style="margin-bottom: 0;">' +
      '<img style="pointer-events: none; touch-callout: none; user-select: none;" src="/assets/images/news-041-4_l.jpg" alt="">' +
      '</figure>'
  },
  {
    id: '042',
    date: '2023.12.19',
    title: '個性派ぞろいのキャラクター＆CVがお披露目！PV第1弾公開！',
    description: '『GREAT PRETENDER razbliuto』のPV第1弾を公開いたしました！',
    image: '/assets/images/news-042_s.jpg',
    text:
      '<p>『GREAT PRETENDER razbliuto』のPV第1弾を公開いたしました！</p>' +
      '<a href="#015" class="video is-small">' +
      '  <figure><img src="/assets/images/pv-poster15.jpg" alt=""></figure>' +
      '</a>' +
      '<p>' +
      'PVでは、記憶をなくした自称・天才コンフィデンスレディのドロシーをはじめ、台湾の裏社会の若頭のジェイや、お調子者の自称・台北イチの天才詐欺師のヤンなど、今作の中心人物がお披露目となりました！<br>' +
      'さらに、個性豊かなキャラクターたちに息を吹き込むキャストも発表！コメントも到着しております。' +
      '<p/>' +
      '<p class="has-text-weight-bold"><a href="/razbliuto/character/dorothy">キャラクター詳細は、こちら＞</a></p>' +
      '<p class="has-text-weight-bold"><a href="/razbliuto/staffcast">キャストコメントは、こちら＞</a></p>'
  },
  {
    id: '043',
    date: '2023.12.19',
    title: 'DMM TVにて24年2月23日（金）0:00より配信開始！北米でも劇場公開決定！',
    description: '『GREAT PRETENDER razbliuto』の、日本国内での配信日時が決定いたしました！ DMM TVにて、2024年2月23日（金）0:00より配信がスタートいたします。',
    image: '/assets/images/no-image-raz.jpg',
    text:
      '<p>' +
      '『GREAT PRETENDER razbliuto』の、日本国内での配信日時が決定いたしました！<br>' +
      'DMM TVにて、2024年2月23日（金）0:00より配信がスタートいたします。' +
      '</p>' +
      '<p>また、北米地域では、24年1月9日（火）～10日(水)にて、劇場公開が決定。中東・北アフリカ地域では日本と同時期での展開が予定されるなど、世界各地で盛り上がりを見せるグレプリを、どうぞご期待くださいませ！</p>'
  },
  {
    id: '044',
    date: '2024.01.19',
    title: '台北國際動漫節での展示ブース出展が決定！『GREAT PRETENDER razbliuto』冒頭約20分アジア先行上映、制作チームトークショー＆サイン会も開催！',
    description: '',
    image: '/assets/images/no-image-raz.jpg',
    text:
      '<p>' +
      '台湾で開催されるアジア最大級の漫画・アニメ・ライトノベル作品の祭典「第12回 台北國際動漫節」の「ICHIBAN JAPAN 日本館」に『GREAT PRETENDER razbliuto』の背景美術やキャラクターデザインなどの貴重な資料を展示するブースを出展することが決定しました！展示は、「ICHIBAN JAPAN 日本館」のProduction I.Gブース内で行われます。<br>' +
      'さらに、『GREAT PRETENDER razbliuto』冒頭約20分を、2月4日（日）15：30より日本館ステージにてアジア先行上映いたします！<br>' +
      '合わせて、制作チームの鏑木ひろ氏（監督）、加藤寛崇氏（キャラクターデザイン）、和田丈嗣氏（プロデューサー）が上映後に登場し、トークショー&サイン会を開催いたします。' +
      '</p>' +
      '<p>' +
      '<em>■開催概要</em><br>' +
      '催事名：台北國際動漫節<br>' +
      '開催期間：2024年2月1日（木）～2月5日（月）10:00～18:00<br>' +
      '開催場所：台北世界貿易センター（台北市信義区信義路5段5号）' +
      '</p>' +
      '<p>' +
      '<em>■関連サイト</em><br>' +
      '「台北國際動漫節」公式サイト：<a href="https://www.ccpa.org.tw/tica/index.php?tpl=11" target="_blank" rel="noopener">https://www.ccpa.org.tw/tica/index.php?tpl=11</a>' +
      '</p>'
  },
  {
    id: '045',
    date: '2024.02.21',
    title: '第2回新潟国際アニメーション映画祭で『GREAT PRETENDER razbliuto』のイベント上映が決定！鏑木ひろ監督、岡田麻衣子プロデューサーがトーク登壇！',
    description: '第2回新潟国際アニメーション映画祭にて、3 月17 日（日）に『GREAT PRETENDER razbliuto』のイベント上映を開催することが決定いたしました！',
    image: '/assets/images/news-045_s.jpg',
    text:
      '<p>' +
      '第2 回新潟国際アニメーション映画祭にて、3 月17 日（日）に『GREAT PRETENDER razbliuto』のイベント上映を開催することが決定いたしました！<br>' +
      'さらに、鏑木ひろ監督、岡田麻衣子プロデューサーが登壇し、本作についてのトークを行います。ぜひ現地へ足をお運びください！' +
      '</p>' +
      '<figure oncontextmenu="return false;">' +
      '<img style="pointer-events: none; touch-callout: none; user-select: none;" src="/assets/images/news-045_l.jpg" alt="">' +
      '</figure>' +
      '<p>' +
      '<em>■概要</em><br>' +
      '上映作品：『GREAT PRETENDER razbliuto』<br>' +
      '作品時間：89 分<br>' +
      '上映日：3 月17 日（日）<br>' +
      '開催場所：市民プラザ<br>' +
      '登壇：鏑木ひろ、岡田麻衣子' +
      '</p>' +
      '<p>' +
      '<em>■関連サイト</em><br>' +
      '「新潟国際アニメーション映画祭」公式サイト：<a href="https://niigata-iaff.net/" target="_blank" rel="noopener">https://niigata-iaff.net/</a>' +
      '</p>'
  },
  {
    id: '046',
    date: '2024.02.23',
    title: '2/23(金)0時よりDMM TVにて独占配信スタート！PV第2弾公開！',
    description: 'ついに本日2月23日(金)0時より、『GREAT PRETENDER razbliuto』がDMM TVにて独占配信が開始されました！',
    image: '/assets/images/news-046_s.jpg',
    text:
      '<p>' +
      'ついに本日2月23日(金)0時より、『GREAT PRETENDER razbliuto』がDMM TVにて独占配信が開始されました！<br>' +
      'そして、配信スタートを記念し、PV第2弾も公開！' +
      '</p>' +
      '<p>' +
      '自称・天才コンフィデンスレディだったが、かつての記憶を失ってしまったドロシー（CV.小松由佳）が、台湾黒社会の若頭のジェイ（CV.武内俊輔）と出会うことで騒動に巻き込まれ、波乱の展開を感じさせる映像となっております！' +
      '</p>' +
      '<a href="#016" class="video is-small">' +
      '  <figure><img src="/assets/images/pv-poster16.jpg" alt=""></figure>' +
      '</a>'
  },
  {
    id: '047',
    date: '2024.02.23',
    title: '第1期『GREAT PRETENDER』の配信プラットフォームが拡大！',
    description: '『GREAT PRETENDER razbliuto』の配信開始に合わせて、前作『GREAT PRETENDER』の配信プラットフォームが拡大！',
    image: '/assets/images/no-image-raz.jpg',
    text:
      '<p>' +
      '『GREAT PRETENDER razbliuto』の配信開始に合わせて、前作『GREAT PRETENDER』の配信プラットフォームが拡大！<br>' +
      'これまで配信してきた「Netflix」や、『GREAT PRETENDER razbliuto』の配信も開始した「DMM TV」はもちろん、「プライムビデオ」や「dアニメストア」など10サイトにて、本日より配信が開始いたしました！<br>' +
      'ぜひ、この機会に、コンフィデンスマンたちによる痛快な騙し合いをお楽しみくださいませ！' +
      '</p>' +
      '<em>■概要</em><br>' +
      '<ul>' +
      '<li>DMM TV：<a href="https://tv.dmm.com/vod/" target="_blank" rel="noopener">https://tv.dmm.com/vod/</a></li>' +
      '<li>Amazon Prime Video：<a href="https://www.amazon.co.jp/gp/video/storefront/" target="_blank" rel="noopener">https://www.amazon.co.jp/gp/video/storefront/</a></li>' +
      '<li>dアニメストア：<a href="https://anime.dmkt-sp.jp/animestore/" target="_blank" rel="noopener">https://anime.dmkt-sp.jp/animestore/</a></li>' +
      '<li>FOD：<a href="https://fod.fujitv.co.jp/" target="_blank" rel="noopener">https://fod.fujitv.co.jp/</a></li>' +
      '<li>Hulu：<a href="https://www.hulu.jp/?cmp=10102&utm_source=PC&utm_medium=Display&utm_campaign=JP_DM_Display_Others&waad=MRHJnZqw" target="_blank" rel="noopener">https://www.hulu.jp/?cmp=10102&utm_source=PC&utm_medium=Display&utm_campaign=JP_DM_Display_Others&waad=MRHJnZqw</a></li>' +
      '<li>Lemino：<a href="https://lemino.docomo.ne.jp/" target="_blank" rel="noopener">https://lemino.docomo.ne.jp/</a></li>' +
      '<li>Netflix：<a href="https://www.netflix.com/jp/" target="_blank" rel="noopener">https://www.netflix.com/jp/</a></li>' +
      '<li>U-NEXT：<a href="https://video.unext.jp/" target="_blank" rel="noopener">https://video.unext.jp/</a></li>' +
      '<li>アニメ放題：<a href="https://www.animehodai.jp/" target="_blank" rel="noopener">https://www.animehodai.jp/</a></li>' +
      '<li>バンダイチャンネル：<a href="https://www.b-ch.com/" target="_blank" rel="noopener">https://www.b-ch.com/</a></li>' +
      '</ul>'
  },
  {
    id: '048',
    date: '2024.03.01',
    title: '『グレプリ』に、再び「五十嵐」が潜伏…！？腕利きコンフィデンスマン(？)五十嵐役・小手伸也さんより配信記念コメント到着！',
    description: 'DMM TV にて現在独占配信中の『GREAT PRETENDER razbliuto』。 配信スタートを記念して、「コンフィデンスマンJP 」の名物キャラクター・五十嵐…',
    image: '/assets/images/news-048_s.jpg',
    text:
      '<p>' +
      'DMM TV にて現在独占配信中の『GREAT PRETENDER razbliuto』。<br>' +
      '配信スタートを記念して、「コンフィデンスマンJP 」の名物キャラクター・五十嵐として本作にも登場をしている、小手伸也さんよりコメントが到着いたしました！<br>' +
      '</p>' +
      '<p>' +
      '第1期でも登場した五十嵐が、再び『グレプリ』の世界に現れます！どこに登場するのか、ぜひ本編でお確かめくださいませ！<br>' +
      '</p>' +
      '<p>' +
      '【五十嵐役・小手伸也さんコメント】<br>' +
      '次元を超えて広がる「コンフィデンスマンの世界」！その二次元世界を担う『GREAT PRETENDER』が新たな物語を紡ぐとなれば、当然三次元を代表するこの俺が再び二次元化するしかないだろう！一次元だろうが四次元だろうが変幻自在、まさに神出鬼没の凄腕コンフィデンスマン「五十嵐」！いたのか？とは言わせないぜ！' +
      '</p>' +
      '<figure oncontextmenu="return false;">' +
      '<img style="pointer-events: none; touch-callout: none; user-select: none;" src="/assets/images/news-048-1_l.jpg" alt="">' +
      '</figure>' +
      '<figure oncontextmenu="return false;">' +
      '<img style="max-height: 400px; max-width: 400px; width: auto; height: auto; pointer-events: none; touch-callout: none; user-select: none;" src="/assets/images/news-048-2_l.jpg" alt="">' +
      '</figure>'
  },
  {
    id: '049',
    date: '2024.03.01',
    title: '第1期＆『razbliuto』の感想を投稿して豪華賞品を手に入れよう！「#グレプリ最高」キャンペーン開催！',
    description: '『GREAT PRETENDER』の各配信サービスでの配信開始と、DMM TVでの『GREAT PRETENDER razbliuto』の配信開始を記念して、「#グレプリ最高」キャンペーンを…',
    image: '/assets/images/no-image-raz.jpg',
    text:
      '<p>' +
      '『GREAT PRETENDER』の各配信サービスでの配信開始と、DMM TVでの『GREAT PRETENDER razbliuto』の配信開始を記念して、「#グレプリ最高」キャンペーンを開催いたします！' +
      '</p>' +
      '<p>' +
      '特設ページに掲載された『GREAT PRETENDER』（第1弾）または、『GREAT PRETENDER razbliuto』（第2弾）の場面写真からお好きなシーンを選択して、X（旧Twitter）で感想や推しコメントを投稿いただきます。キャンペーン期間中にハッシュタグ「#グレプリ最高」をつけて投稿いただいた方の中から、抽選で豪華賞品をプレゼントいたします。<br>' +
      '投稿は何回でも可能ですので、たくさんの投稿をお待ちしております！' +
      '</p>' +
      '<p>' +
      '<em>【キャンペーン特設ページ】<br>' +
      '<a target="_blank" rel="noopener" href="https://greatpretender.smartbuzz.jp/Scene/66/">https://greatpretender.smartbuzz.jp/Scene/66/</a>' +
      '</em>' +
      '</p>' +
      '<br>' +
      '<em>【キャンペーン内容】</em><br>' +
      '<p>' +
      '◆第1弾：『GREAT PRETENDER』の感想・推しコメントを投稿！<br>' +
      '◆第2弾：『GREAT PRETENDER razbliuto』の感想・推しコメントを投稿！' +
      '</p>' +
      '<p>' +
      '＜キャンペーン期間＞<br>' +
      '第1弾：2024年3月1日(金)17:00～2024年3月7日(木)23:59<br>' +
      '第2弾：2024年3月8日(金)00:00～2024年3月14日(木)23:59<br>' +
      '</p>' +
      '<p>' +
      '＜参加方法＞<br>' +
      'STEP①<br>' +
      'アニメ『GREAT PRETENDER』シリーズ公式Xアカウント（@GrePre_anime）をフォロー<br>' +
      '※当選者の発表はXのDMにてご案内いたしますので、必ずフォローしてください。<br>' +
      '</p>' +
      '<p>' +
      'STEP②<br>' +
      '場面写真からお好きなシーンを選択し、ハッシュタグ「#グレプリ最高」を付けて感想や推しコメントをX（旧Twitter）で投稿。<br>' +
      '</p>' +
      '<p>' +
      '＜プレゼント内容＞<br>' +
      '◆第1弾<br>' +
      '・エダマメ役・小林千晃さん＆ローラン役・諏訪部順一さんサイン入り非売品B2番宣ポスター：1名さま<br>' +
      '・スタッフサイン入り非売品B2番宣ポスター：1名さま<br>' +
      '・非売品B2番宣ポスター2種セット：5名さま<br>' +
      '・グレプリグッズセット（クリアファイルセット／エダマメアクリルスタンド／ローランアクリルスタンド）：5名さま<br>' +
      '</p>' +
      '<p>' +
      '◆第2弾<br>' +
      '・ドロシー役・小松由佳さん＆ジェイ役・武内駿輔さんサイン入り台本：4名さま<br>' +
      '・スタッフサイン入り非売品B2番宣ポスター：5名さま<br>' +
      '・非売品B2番宣ポスター：10名さま<br>' +
      '</p>' +
      '<br>' +
      '＜注意事項＞<br>' +
      '<ul>' +
      '<li>アニメ『GREAT PRETENDER』シリーズ公式X（旧Twitter）アカウント(@GrePre_anime)をフォローしてください。また、指定のハッシュタグがないポストは、抽選の対象となりませんので、ご注意ください。</li>' +
      '<li>応募期間外の投稿は抽選の対象になりませんのでご注意ください。</li>' +
      '<li>当選のご連絡はX（旧Twitter）のダイレクトメッセージでお送りいたします。</li>' +
      '<li>期日までに氏名・住所等をご返信いただけた方にのみ賞品をお届けさせていただきます。</li>' +
      '<li>期日までにご返信がない場合は、当選の権利が無効となりますのでご注意ください。</li>' +
      '<li>システムの仕様上「みんなの投稿」欄に反映されない場合がありますが、抽選の対象から外れる事はございません。</li>' +
      '<li>発送先は日本国内に限ります。</li>' +
      '</ul>' +
      '<br>' +
      '<em>' +
      '【DMM TV『GREAT PRETENDER razbliuto』視聴ページ】<br>' +
      '<a target="_blank" rel="noopener" href="https://t.co/VPVCjqutPB">https://t.co/VPVCjqutPB</a>' +
      '</em>'
  }
]



// WEBPACK FOOTER //
// ./src/data/news.js